import axios from 'axios';

export const headers = (session) => {
    return {
        'X-Admin-User-Email': session.email,
        'X-Admin-User-Token': session.token
    }
};

export const get = (endpoint, session, params = {}, options = {}) => {
    return axios.get(
        endpoint,
        {
            params,
            headers: headers(session),
            ...options,
        }
    ).then((axiosResponse) => {
        if (axiosResponse?.response?.data?.status === 'error') {
            console.log(axiosResponse?.response);
        } else {
            return axiosResponse;
        }
    });
};

export const post = (endpoint, session, params = {}, options = {}) => {
    return axios.post(
        endpoint,
        params,
        {
            headers: headers(session),
            ...options,
        }
    );
};

export const put = (endpoint, session, params = {}) => {
    return axios.put(
        endpoint,
        params,
        {
            headers: headers(session)
        }
    );
};

export const patch = (endpoint, session, params = {}) => {
    return axios.patch(
        endpoint,
        params,
        {
            headers: headers(session)
        }
    );
};
